<template>
  <section class="banner">
    <div class="container">
      <a-typography-title :level="1">
        CostPilot<br>
        一站式企业云成本管家
      </a-typography-title>
      <a-typography-paragraph>
        {{
          'CostPilot是基于FinOps理念开发的一站式企业云成本管理平台，' +
          '通过对各种云资源成本的深入洞察，快速生成成本报告，' +
          '并从多种角度提供定制化成本优化建议，助力企业IT成本优化高达50%。'
        }}
      </a-typography-paragraph>
      <a-space :size="$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)?'large':'small'">
        <a-button type="link" class="button_1"
                  @click="$RQ.GoGSS()">
          免费体验
        </a-button>
        <a-button type="link" class="button_1"
                  @click="$Store.Page().openModal('modalFormCollection', 'demoCostPilot')">
          预约咨询
        </a-button>
      </a-space>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';

export default {
  name: 'product_banner',
  methods: {
    /**
     * 点击按钮
     */
    async clickButton(): Promise<any> {
      window._hmt && window._hmt.push([ '_trackEvent', 'CostPilot_1', 'click' ]);
      await $FN.WaitTime(100);
      $Store.Page().openModal('modalFormCollection', 'freeUse');
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/productCostPilot/';

.banner {
  overflow: hidden;
  position: relative;
  z-index: 0;
  padding: 0 @padding;
  .bg('@{image}banner.jpg');
  background-size: cover;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: 120px 0 50px;
    margin: 0 auto;
    .borderBox();
  }
}

h1.ant-typography {
  margin: 0;
  .font(justify, @banner_title, @color_black, @banner_title, true);
}

div.ant-typography {
  max-width: 450px;
  margin: 20px 0 0;
  .font(justify, @text+@line, @color_black, @text);
}

.ant-space {
  margin-top: 20px;
}

@media screen and (max-width: -1px+@grid_xl) {
  .banner {
    .container {
      padding: 80px 0 30px;
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  h1.ant-typography {
    .font(justify, @banner_title_mo, @color_black, @banner_title_mo, true);
  }
  
  div.ant-typography {
    margin: 10px 0 0;
    .font(justify, @text_mo+@line_mo, @color_black, @text_mo);
  }
  
  .ant-space {
    margin-top: 10px;
  }
}

@media screen and (max-width: -1px+@grid_xs) {
  .banner {
    background-position: center left !important;
  }
}
</style>